export const blockInfo = {
  E: { totalFloors: 12, habitableFloors: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
  F: { totalFloors: 9, habitableFloors: [0, 1, 2, 3, 4, 5, 6, 7, 8] },
  K: { totalFloors: 3, habitableFloors: [0, 1, 2] },
  J: { totalFloors: 5, habitableFloors: [0, 1, 2, 3] },
  H: { totalFloors: 9, habitableFloors: [0, 1, 2, 3, 4, 5, 6, 7, 8] }
  // F2: { totalFloors: 8, habitableFloors: [0, 1, 2, 3, 4, 5, 6, 7] },
  // F3: { totalFloors: 7, habitableFloors: [0, 1, 2, 3, 4, 5, 6] }
}
